import { Directive, ElementRef, HostListener, NgModule, OnDestroy, OnInit, Optional } from '@angular/core';
import {ControlValueAccessor, NgControl} from '@angular/forms';

@Directive({
  selector: 'input[type=text], textarea'
})
export class NgxTrimDirective implements OnInit, OnDestroy {

  private _trim: '' | 'blur' | false;

  public set trim (trimOption: '' | 'blur' | false) {
    if (trimOption !== '' && trimOption !== 'blur' && trimOption !== false) {
      console.warn(`Note: The value ${JSON.stringify(trimOption)} is not assignable to the trim attribute.
        Only blank string (""), "blur" or false is allowed.`);

      this._trim = false;
      return;
    }

    this._trim = trimOption;
  }

  public get trim () {
    return this._trim;
  }

  private _valueAccessor: ControlValueAccessor;
  private _writeValue: (value) => void;

  constructor (
    private elementRef: ElementRef,
    @Optional() private ngControl: NgControl,
  ) { }

  private static trimValue (el, value) {
    el.value = value.trim();
  }

  ngOnInit (): void {
    if (!this.ngControl) {
      console.warn('Note: The trim directive should be used with one of ngModel, formControl or formControlName directives.');
      return;
    }
    this.trim = '';

    this._valueAccessor = this.ngControl.valueAccessor;
    this._writeValue = this._valueAccessor.writeValue;
    this._valueAccessor.writeValue = (value) => {
      const _value =
        this.trim === false || !value || 'function' !== typeof value.trim
          ? value
          : value.trim();

      if (this._writeValue) {
        this._writeValue.call(this._valueAccessor, _value);
      }

      if (value !== _value) {
        if (this._valueAccessor['onChange']) {
          this._valueAccessor['onChange'](_value);
        }
        if (this._valueAccessor['onTouched']) {
          this._valueAccessor['onTouched']();
        }
      }
    };
  }

  ngOnDestroy (): void {
    if (this._valueAccessor && this._writeValue) {
      this._valueAccessor.writeValue = this._writeValue;
    }
  }

  @HostListener('blur', [
    '$event.target',
    '$event.target.value',
  ])
  onBlur (el: any, value: string): void {
    if (this.trim === false) { return; }

    if ((this.trim === '' || 'blur' === this.trim) && 'function' === typeof value.trim && value.trim() !== value) {
      NgxTrimDirective.trimValue(el, value);
    }

  }

}

@NgModule({
  declarations: [
    NgxTrimDirective
  ],
  imports: [],
  exports: [
    NgxTrimDirective
  ]
})
export class NgxTrimDirectiveModule { }
